// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1IQ_d","title":"Info_title__2WRbn","links":"Info_links__1j8vk","link":"Info_link__3IP08","logo":"Info_logo__3i--k"};